import { render, staticRenderFns } from "./PlayAudio.vue?vue&type=template&id=b312c27a&scoped=true&"
import script from "./PlayAudio.vue?vue&type=script&lang=js&"
export * from "./PlayAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b312c27a",
  null
  
)

export default component.exports